import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SubmissionsService } from '../../service/submissions.service';
import { Location } from '@angular/common';
import { ReviewsService } from '../../service/reviews.service';
import { CardViewComponent } from '../card-view/card-view.component';
import { InfoService } from '../../service/info.service';
import { TranslateService } from '@ngx-translate/core';
import { Track } from '../../model/track';
import { Review } from '../../model/paper';
import { EventsService } from 'src/app/service/events.service';
import { Submission } from '../../model/paper';
import { NavbarService } from 'src/app/service/navbar.service';
import { ReviewStatus } from 'src/app/enum/review.status';
import { Title } from '@angular/platform-browser';
import { AdminService } from 'src/app/service/admin.service';
import { ReviewsConfigurationService } from 'src/app/service/reviews.configuration.service';

@Component({
  selector: 'app-submission-view',
  templateUrl: './submission-view.component.html',
  styleUrls: ['./submission-view.component.scss', '../card-view/card-view.component.scss']
})
export class SubmissionViewComponent extends CardViewComponent implements OnInit {
  constructor(
    router: Router, route: ActivatedRoute,
    submissionService: SubmissionsService, location: Location,
    infoService: InfoService, reviewsService: ReviewsService,
    private translateService: TranslateService, private eventsService: EventsService,
    private navbarService: NavbarService,
    private titleService: Title,
    private adminService: AdminService,
    private reviewsConfigurationService: ReviewsConfigurationService,
  ) {
    super(router, route, submissionService, location, infoService, reviewsService);
  }

  submission: Submission;
  permissionChecked = false;

  ngOnInit() {
    setTimeout(() => {
      this.navbarService.loadingStart();

      // ─── Pré-fetch (fire-and-forget) ──────────────────────────────────
      // `eventId` e `submissionId` já estão na rota — disparamos os requests
      // que o paper-info filho vai precisar (reviewConfig, publicationInfo)
      // ANTES dele montar. Os services têm in-flight dedup; quando paper-info
      // fizer sua própria subscribe, hit-de-cache (ou compartilha o request
      // em vôo). Ganho: elimina o "gap" entre geração 1 (submission/event)
      // e geração 2 (componentes filhos), paralelizando.
      const parentEventIdRaw = this.route.parent?.snapshot.params.eventId;
      const submissionIdRaw = this.route.snapshot.paramMap.get('id');
      const submissionId = parseInt(submissionIdRaw, 10);
      if (parentEventIdRaw) {
        this.reviewsConfigurationService.getReviewsConfiguration(parentEventIdRaw).subscribe(() => {}, () => {});
      }
      if (submissionId) {
        this.submissionService.getPublicationInfo(submissionId).subscribe(() => {}, () => {});
      }

      this.route.queryParams.subscribe(() => {
        const isAdminRoute = this.adminService.isEventAdminRoute(this.route.snapshot);
        this.submissionService
          .getSubmission(submissionId, true, isAdminRoute)
          .subscribe(submission => {
            // Render UNBLOCKED: assim que `event` chega, paper-info renderiza.
            // Reviews (check de redirect pro reviewer com revisão NOTIFIED)
            // roda EM PARALELO mas NÃO gateia o render — caso raro de redirect
            // continua funcionando (ele acontece pós-render se necessário).
            this.eventsService.getEventByTrack(submission.trackID).subscribe(event => {
              this.submission = submission;
              this.submission.event = event;
              this.submission.track = event.tracks.find(track => submission.trackID === track.id);
              this.updateHeadTitle();
              this.navbarService.loadingStop();

              const parentEvent = Number(this.route.parent.snapshot.params.eventId);
              if (parentEvent && parentEvent !== submission.event.id) {
                this.router.navigate(['/error/403']);
                return;
              }

              this.permissionChecked = true;
              this.loaded = true;
            });

            // Check de redirect non-blocking (em paralelo com o render).
            // Bug pendente: endpoint pode retornar 404 quando lista vazia —
            // ver [[paper-review-list-404-pending]]. Tratamos via `|| []`.
            this.reviewsService.getReviewsBySubmissionId(submission.id).subscribe(
              reviews => {
                (reviews || []).some((review: Review) => {
                  if (review.userId === this.infoService.user.id && review.status === ReviewStatus.NOTIFIED) {
                    this.router.navigate(['/confirm/reviewSubmission', review.id]);
                    return true;
                  }
                });
              },
              () => {}, // erro silencioso — render já aconteceu
            );
          });
      });
    });
  }

  updateHeadTitle(){
    if (this.submission.event) {
      let eventAcronymYear = this.submission.event.acronym + " " + this.submission.event.year + " - ";
      let oldTitle = this.titleService.getTitle();
      if (!oldTitle.includes(eventAcronymYear)){
        this.titleService.setTitle(eventAcronymYear + this.titleService.getTitle());
      }
    }
  }
}
